/* recovered from production bundle — lib/auth */
// @ts-nocheck

import { TOKEN_KEY, LEGACY_TOKEN_KEY, THEME_KEY, LEGACY_THEME_KEY } from './constants';

export function getToken(): string | null {
  return localStorage.getItem(TOKEN_KEY) ?? localStorage.getItem(LEGACY_TOKEN_KEY);
}

export function setToken(token: string) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(LEGACY_TOKEN_KEY);
}

export function getThemePreference(): 'light' | 'dark' {
  if (typeof window === 'undefined') {
    return 'light';
  }
  const stored = localStorage.getItem(THEME_KEY) ?? localStorage.getItem(LEGACY_THEME_KEY);
  if (stored === 'light' || stored === 'dark') {
    return stored;
  }
  if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

export function applyTheme(theme: 'light' | 'dark') {
  document.documentElement.classList.toggle('dark', theme === 'dark');
  localStorage.setItem(THEME_KEY, theme);
}

export function apiPath(path: string): string {
  const segment = path.startsWith('/') ? path.slice(1) : path;
  const marker = '/public';
  const idx = window.location.pathname.indexOf(marker);
  if (idx >= 0) {
    return `${window.location.pathname.slice(0, idx + marker.length)}/${segment}`;
  }
  // Must include search (query string); .pathname alone drops ?offset=&filters= etc.
  const resolved = new URL(segment, window.location.href);
  return resolved.pathname + resolved.search;
}
